import {Step, StepType} from "./step";
import {AnalysisStatusEnum} from "./analysis-status";
import {TyreAnalysis} from "./analysis";
import {Picture, PictureStatus, PictureType} from "./picture";

export class TyrePicture extends Picture {
    step: Step;
    cbdValid?: boolean;

    constructor(step: Step) {
      super(step.toString(), PictureType.TYRE);
      this.step = step;
    }

  public static fromDB(picture: Picture){
      const tyrePicture = new TyrePicture(Step.fromString(picture.key));
      tyrePicture.status = picture.status;
      tyrePicture.uploadInfo = picture.uploadInfo;
      tyrePicture.data = picture.data;
      tyrePicture.url = picture.url;
      return tyrePicture;
  }

  public static fromAnalysis(tyreAnalysis: TyreAnalysis, type: StepType): TyrePicture {
    if (tyreAnalysis.position) {
      const picture = new TyrePicture(new Step(tyreAnalysis.position, type));
      picture.status = tyreAnalysis.status === AnalysisStatusEnum.STARTED ?
        PictureStatus.INVALID : PictureStatus.VALID;
      picture.uploadInfo = {
        id: tyreAnalysis.id,
        uploadUrl: {
          fileName: tyreAnalysis.uploadUrl?.fileName,
          url: tyreAnalysis.uploadUrl?.url
        }
      };
      return picture;
    } else {
      throw new Error('tyreAnalysis position must be defined');
    }
  }
}
